import { Context, type Effect } from "effect";
import type { BrowserFilters, BrowserContextWindow, BrowserSnapshot, BrowserCleared, ObservabilityFailure, TraceFilters, TraceListing, TraceDetail, TracesCleared } from "./model.ts";

export interface BrowserApiShape {
  readonly list: (workspaceId: string, filters: BrowserFilters) => Effect.Effect<BrowserSnapshot, ObservabilityFailure>;
  readonly context: (workspaceId: string, window: BrowserContextWindow) => Effect.Effect<BrowserSnapshot, ObservabilityFailure>;
  readonly clear: (workspaceId: string) => Effect.Effect<BrowserCleared, ObservabilityFailure>;
}
export class BrowserApi extends Context.Service<BrowserApi, BrowserApiShape>()("workerstation/frontend/BrowserApi") {}
export interface TraceApiShape {
  readonly list: (workspaceId: string, filters: TraceFilters) => Effect.Effect<TraceListing, ObservabilityFailure>;
  readonly read: (workspaceId: string, traceId: string, stationId?: string) => Effect.Effect<TraceDetail, ObservabilityFailure>;
  readonly clear: (workspaceId: string, stationId?: string) => Effect.Effect<TracesCleared, ObservabilityFailure>;
}
export class TraceApi extends Context.Service<TraceApi, TraceApiShape>()("workerstation/frontend/TraceApi") {}
